import React, { useState, useEffect } from 'react';
import { fetchConfigurations, updateConfiguration } from '../api/configurations';
import { Box, TextField, Button, Typography, Snackbar, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

function ManageConfigurationsPage() {
    const { t } = useTranslation();
    const [configurations, setConfigurations] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    useEffect(() => {
        const loadConfigurations = async () => {
            try {
                const data = await fetchConfigurations();
                setConfigurations(data);
            } catch (err) {
                setSnackbar({ open: true, message: err.message, severity: 'error' });
            }
        };

        loadConfigurations();
    }, []);

    const handleUpdate = async (key, value) => {
        try {
            await updateConfiguration(key, value);
            setSnackbar({ open: true, message: `${key} updated successfully.`, severity: 'success' });
        } catch (err) {
            setSnackbar({ open: true, message: err.message, severity: 'error' });
        }
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>Manage Configurations</Typography>

            <Grid container spacing={2}>
                {Object.entries(configurations).map(([key, value]) => (
                    <Grid item xs={12} key={key}>
                        <Paper sx={{ p: 2 }}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={4} lg={3}>
                                    <Typography variant="subtitle2" sx={{
                                        fontFamily: 'monospace',
                                        fontSize: '0.875rem',
                                        wordBreak: 'break-all',
                                        minHeight: '40px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        {key}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6} lg={7}>
                                    <TextField
                                        fullWidth
                                        label={t('configurations.value')}
                                        value={value || ''}
                                        onChange={(e) => setConfigurations({ ...configurations, [key]: e.target.value })}
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={2} lg={2}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => handleUpdate(key, configurations[key])}
                                        size="small"
                                    >
                                        Update
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <Snackbar
                open={snackbar.open}
                message={snackbar.message}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
            />
        </Box>
    );
}

export default ManageConfigurationsPage;
